export default {
      id: "headphones-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#headphones-usage",
      toString: function () {
        return this.url;
      }
    }